var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBlob)?_c('text',{staticClass:"o-tachyon-particle"},[_vm._v(" "+_vm._s(_vm.blob)+" ")]):_c('circle',{staticClass:"o-tachyon-particle",attrs:{"r":"2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }